var _circle, _path, _path2, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVatCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 24.746,
    cy: 31.258,
    r: 1.597
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M21.26 15.41h-2.357c-.615 0-1.205.224-1.665.632-1.591 1.411-5.339 5.064-7.326 9.741-1.435 3.376-1.236 6.193-1.246 6.386-.036.678.414 3.92 4.201 4.46 2.281.326 5.542.496 8.394.512 2.852-.016 6.114-.186 8.394-.512 3.787-.541 4.238-3.782 4.201-4.46-.01-.193.188-3.01-1.246-6.386-1.987-4.676-5.736-8.33-7.326-9.741a2.504 2.504 0 00-1.665-.632h-2.357zM18.383 14.786h5.634c.3 0 .576-.201.718-.523l2.991-6.768c.163-.369.122-.82-.104-1.135-.451-.627-1.385-1.42-2.986-.688-2.431 1.111-2.216 2.081-5.226.566-2.1-1.057-3.604.04-4.322.799-.294.311-.366.829-.176 1.244l2.759 5.996c.145.314.417.509.712.509z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M17.768 31.267l7.024-7.023"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 18.03,
    cy: 24.289,
    r: 0.305
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatCancel);
export default __webpack_public_path__ + "static/media/vatCancel.dd171b714ea9474df6d884d1d48b9cf1.svg";
export { ForwardRef as ReactComponent };